import React, { useRef } from 'react'
import _ from 'lodash/fp'
import { Link } from 'react-router-dom'

import colors from '@fe/ui/colors'

import Typography from '@material-ui/core/Typography'
import { Hidden } from '@material-ui/core'
import withStyles from '@material-ui/core/styles/withStyles'

import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
  InfoWindow
} from 'react-google-maps'
import { SearchBox } from 'react-google-maps/lib/components/places/SearchBox'

import { genericWordKiller } from '../util'

// Be careful with this as it is a generated style, just leave it alone
const mapStyles = [
  {
    featureType: 'administrative.land_parcel',
    stylers: [
      {
        visibility: 'off'
      }
    ]
  },
  {
    featureType: 'administrative.neighborhood',
    stylers: [
      {
        visibility: 'off'
      }
    ]
  },
  {
    featureType: 'poi',
    elementType: 'labels.text',
    stylers: [
      {
        visibility: 'off'
      }
    ]
  },
  {
    featureType: 'poi.business',
    stylers: [
      {
        visibility: 'off'
      }
    ]
  },
  {
    featureType: 'road',
    elementType: 'labels',
    stylers: [
      {
        visibility: 'off'
      }
    ]
  },
  {
    featureType: 'road',
    elementType: 'labels.icon',
    stylers: [
      {
        visibility: 'off'
      }
    ]
  },
  {
    featureType: 'transit',
    stylers: [
      {
        visibility: 'off'
      }
    ]
  },
  {
    featureType: 'water',
    elementType: 'labels.text',
    stylers: [
      {
        visibility: 'off'
      }
    ]
  }
]

export const InfoWindowStyles = () => ({
  container: {
    width: 300
  },
  wrapper: {
    width: '100%',
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between'
  },
  price: {
    display: 'inline',
    color: colors.lightGreen
  },
  compareAtPrice: {
    display: 'inline',
    color: colors.secondaryDarkGreyTransparent,
    textDecoration: 'line-through'
  },
  link: {
    display: 'inline',
    marginLeft: 10
  },
  bookLink: {
    color: colors.lightGreen
  },

  readLink: {
    color: colors.secondaryDarkGreyTransparent
  }
})

class GlfrInfoWindowBase extends React.Component {
  render () {
    const { classes, visible, title, subtitle, link, media = undefined, left = undefined, right = undefined, small = false, onCloseClick } = this.props
    return (
      <>
        {visible && (
          <InfoWindow
            onCloseClick={onCloseClick}
            defaultOptions={{ disableAutoPan: true }}
          >
            <div className={classes.container}>
              <div>
                {media && (
                  <div style={{
                    backgroundImage: media,
                    height: 200,
                    width: '100%',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                  }}
                  />)}
                <Typography
                  component={link ? Link : undefined}
                  to={link}
                  noWrap
                  variant={small ? 'subtitle1' : 'h6'}
                >
                  {small ? genericWordKiller(title) : title}
                </Typography>
                {!small && <Typography variant='subtitle1'>{subtitle}</Typography>}
              </div>
              {(left || right) && (
                <div className={classes.wrapper}>
                  {left && left}
                  {right && (
                    <Hidden smDown>
                      {right}
                    </Hidden>
                  )}
                </div>
              )}
            </div>
          </InfoWindow>
        )}
      </>
    )
  }
}

export const GlfrInfoWindow = _.compose(
  withStyles(InfoWindowStyles)
)(GlfrInfoWindowBase)

// Creates a little image of a green circle and puts it on a marker
export const GenerateUserPositionMarker = (position) => {
  const cv = document.createElement('canvas')
  const ct = cv.getContext('2d')

  const w = 24
  const h = 24
  cv.width = w
  cv.height = h

  ct.strokeStyle = colors.white
  ct.fillStyle = colors.primaryDarkGreen
  ct.lineWidth = 2
  ct.beginPath()
  ct.arc(w / 2, h / 2, h / 2 - ct.lineWidth * 2, 0, 2 * Math.PI)
  ct.closePath()
  ct.stroke()
  ct.fill()

  const url = cv.toDataURL()

  return (
    <Marker
      title='You'
      icon={{
        url
      }}
      position={{ lat: _.get('latitude', position), lng: _.get('longitude', position) }}
    />
  )
}

/*
  The inner map sets some default style/zoom/ui things
  and wraps the GoogleMap nice and tightly with requried props
  Note: the props are unfolded after default props, so you can supply different values from outside
*/
const InnerMap = withScriptjs(withGoogleMap(props => {
  const { mapRef, getRef = () => { }, ...rest } = props
  const ref = useRef()
  getRef(ref)
  return (
    <GoogleMap
      ref={ref}
      defaultZoom={11}
      mapTypeId='roadmap'
      styles={mapStyles}
      options={{
        disableDefaultUI: true,
        gestureHandling: 'greedy'
      }}
      {...rest}
    />
  )
}))

/*
  The outer map takes props like center position and children (Markers)
  It also sets the required props for GoogleMap
  Note: the props are unfolded after default props, so you can supply different values from outside
 */
export default class Map extends React.Component {
  onPlacesChanged = () => {
    let places
    let newBounds

    if (this.searchBox) {
      places = this.searchBox.getPlaces()
      if (_.size(places) >= 1) {
        newBounds = _.flow(
          _.head,
          _.get('geometry'),
          _.get('viewport')
        )(places)

        if (_.size(places) > 1) {
          console.warn('found more than one place, going to the first in the list.')
        }
      }
    }
    if (this.map && newBounds) {
      this.map.fitBounds(newBounds)
    }
  }

  render () {
    const getRef = ref => {
      if (this.props.getRef) {
        this.props.getRef(ref)
      }
      this.map = ref && ref.current
    }
    return (
      <InnerMap
        googleMapURL='https://maps.googleapis.com/maps/api/js?key=AIzaSyAawSsTxr4U4RWbjWgvj2gB02Gl7xnlZ9k&libraries=geometry,drawing,places'
        loadingElement={<div style={{ height: '100%' }} />}
        containerElement={<div style={{ height: 'calc(100vh - 64px)' }} />}
        mapElement={<div style={{ height: '100%' }} />}
        {...this.props}
        getRef={getRef}
      >
        <SearchBox
          ref={ref => { this.searchBox = ref }}
          controlPosition={2} // 2 is middle, 1 is left and 3 is probably right
          onPlacesChanged={this.onPlacesChanged} //eslint-disable-line
        >
          <input
            type='text'
            placeholder={this.props.placeholder || 'Find'}
            style={{
              boxSizing: 'border-box',
              border: '1px solid transparent',
              width: '240px',
              height: '32px',
              marginTop: '10px',
              padding: '0 12px',
              borderRadius: '3px',
              boxShadow: '0 2px 6px rgba(0, 0, 0, 0.3)',
              fontSize: '14px',
              outline: 'none',
              textOverflow: 'ellipses'
            }}
          />
        </SearchBox>
        {this.props.children}
      </InnerMap>
    )
  }
}
